import cuid from 'cuid';
import { store } from 'Store/store.index';
import { fileController } from "../Controllers/index";
import {ONE_DRIVE, GOOGLE_DRIVE, DROP_BOX, BOX} from 'Api/drives.constants'
import {blobToBase64, getBaseUrl, storageSetItem, windowActionFn} from 'Utils/utils'
import {
  USER_MESSAGE_CALLBACK,
  LABEL_TOOL_CANCELED,
  LABEL_TOOL_START,
  LABEL_TOOL_END
} from './constants'
/**
 * {id, name, size, isCurrentDoc, account_id, filePath, drive}
 * @typedef {Object} FileInfo
 * @property {String} id 
 * @property {String} name
 * @property {Number} size
 * @property {Boolean} isCurrentDoc (optional) set true, be used for 'getCurrentDoc'
 * @property {String} account_id (optional)
 * @property {String} filePath if be selected from local, can be null, default be set with "'/' + name"
 * @property {String} drive one of [ googledrive, onedrive, box, dropbox, local]
 */
export default class AIPluginDocFns{
  constructor(fnMap){
    this.fnMap = fnMap;
    this.docMap = {};
    // file id => aiFileId
    this.docIdMap = {};
    this.openFileActionId = ''
    this.currentDocAiFileId = '';
    this.currentDoc = null;
    this.searchList = {

    }
    window.__docMap__ = this.docMap;
    this.drivesMap = {
      [GOOGLE_DRIVE]: 'googledrive',
      [ONE_DRIVE]: 'onedrive',
      [BOX]: 'box',
      [DROP_BOX]: 'dropbox',
      'googledrive': GOOGLE_DRIVE,
      'onedrive': ONE_DRIVE,
      'box': BOX,
      'dropbox': DROP_BOX,
    };
    this.registerFn      = this.registerFn.bind(this);
    this.clean           = this.clean.bind(this);
    this.resetCurrentDoc = this.resetCurrentDoc.bind(this);
    this.updateSearch    = this.updateSearch.bind(this);

    this.downloadCloudFile = this.downloadCloudFile.bind(this);
    this.getFileBlob       = this.getFileBlob.bind(this);

    this.addFn_getCurrentDoc     = this.addFn_getCurrentDoc.bind(this);
    this.addFn_isCurrentDocModified = this.addFn_isCurrentDocModified.bind(this);
    this.addFn_getDocMetadata    = this.addFn_getDocMetadata.bind(this);
    this.addFn_getFileStream     = this.addFn_getFileStream.bind(this);
    this.addFn_releaseFileStream = this.addFn_releaseFileStream.bind(this);
    this.addFn_cancelFileStream  = this.addFn_cancelFileStream.bind(this);
    this.addFn_showOpenFileDlg   = this.addFn_showOpenFileDlg.bind(this);
    this.addFn_openFile          = this.addFn_openFile.bind(this);
    this.addFn_setIdToFile       = this.addFn_setIdToFile.bind(this);
    this.addFn_openUrlInBrowser  = this.addFn_openUrlInBrowser.bind(this);

    this.addFn_showMessage       = this.addFn_showMessage.bind(this);
    this.addFn_findTexts         = this.addFn_findTexts.bind(this);
    this.addFn_markTexts         = this.addFn_markTexts.bind(this);
    this.addFn_cleanLastMark     = this.addFn_cleanLastMark.bind(this);
    this.addFn_addAnnot          = this.addFn_addAnnot.bind(this);
    this.addFn_getAnnots         = this.addFn_getAnnots.bind(this);
    this.addFn_removeAnnots      = this.addFn_removeAnnots.bind(this);
    this.addFn_setFormFieldValue = this.addFn_setFormFieldValue.bind(this);
    this.addFn_replaceText       = this.addFn_replaceText.bind(this);
    this.addFn_redactApply       = this.addFn_redactApply.bind(this);
    this.addFn_saveDocument      = this.addFn_saveDocument.bind(this);
    
    this.addFn_addAnnotAtPoint     = this.addFn_addAnnotAtPoint.bind(this);
    this.addFn_removeAnnotsAtPoint = this.addFn_removeAnnotsAtPoint.bind(this);
    this.addFn_getAnnotsContentAtPoint = this.addFn_getAnnotsContentAtPoint.bind(this);
    this.addDocIdToMap             = this.addDocIdToMap.bind(this);

    this.addFn_labelToolStart  = this.addFn_labelToolStart.bind(this);
    this.addFn_labelToolEnd    = this.addFn_labelToolEnd.bind(this);
    this.addFn_labelToolCancel = this.addFn_labelToolCancel.bind(this);
    this.addFn_getFileTexts = this.addFn_getFileTexts.bind(this);
    this.addFn_createProgressBar = this.addFn_createProgressBar.bind(this);
    this.addFn_destroyProgressBar = this.addFn_destroyProgressBar.bind(this);
    this.addFn_checkFilePermission = this.addFn_checkFilePermission.bind(this);
  }

  addDocIdToMap(id, aiFileId){
    this.currentDocAiFileId = aiFileId;
    this.docIdMap[id] = aiFileId;
  }

  registerFn(){
    this.addFn_getCurrentDoc();
    this.addFn_isCurrentDocModified();
    this.addFn_getDocMetadata();
    this.addFn_getFileStream();
    this.addFn_releaseFileStream();
    this.addFn_showOpenFileDlg();
    this.addFn_cancelFileStream();
    this.addFn_openFile();
    this.addFn_showMessage();
    this.addFn_createProgressBar();
    this.addFn_destroyProgressBar();
    this.addFn_setIdToFile();
    this.addFn_findTexts();
    this.addFn_markTexts();
    this.addFn_cleanLastMark();
    this.addFn_addAnnot();
    this.addFn_addAnnotAtPoint();
    this.addFn_removeAnnotsAtPoint();
    this.addFn_getAnnotsContentAtPoint();
    this.addFn_getAnnots();
    this.addFn_removeAnnots();
    this.addFn_redactApply();
    this.addFn_saveDocument();
    this.addFn_openUrlInBrowser();
    this.addFn_setFormFieldValue();
    this.addFn_replaceText();
    this.addFn_labelToolStart();
    this.addFn_labelToolEnd();
    this.addFn_labelToolCancel();
    this.addFn_getFileTexts();
    this.addFn_checkFilePermission();

    let _this = this;
    let Events     = UIExtension.PDFViewCtrl.Events;
    window.pdfui.addViewerEventListener(Events.beforeOpenFile, function(){
      _this.clean()
    })
    window.pdfui.addViewerEventListener(Events.openFileSuccess, function(){
      _this.resetCurrentDoc();
    })
    // window.pdfui.addViewerEventListener(UIExtension.UIEvents.pageNumberChange, (/* pageNumber */) => {
    //   _this.updateSearch()
    // });
    window.pdfui.addViewerEventListener(Events.pageAdded, function() {
      this.searchList = {}//_this.updateSearch()
    })
    window.pdfui.addViewerEventListener(Events.pageRemoved, function() {
      this.searchList = {}// _this.updateSearch()
    })
  }

  async resetCurrentDoc(){
    let doc = await window.pdfui.getCurrentPDFDoc();
    if(doc){
      this.currentDoc = doc;
      this.searchList = {}
      //let info = doc.info;
    }
  }

  async updateSearch(){
    let doc = this.currentDoc || await window.pdfui.getCurrentPDFDoc();
    Object.keys(this.searchList).forEach(async (key)=>{
      const {text} = this.searchList[key];
      let result = await fileController.findTextInWholeDoc({doc, text});
      if(result.length === 0){
        resolve({ret:0, data:{searchKey:'', count:0}})
        return;
      }
      this.searchList[key] = {list: result, text};
    })
  }

  clean(){
    //window.__docMap__ = this.docMap = {};
    // file id => aiFileId
    if(this.currentDoc){
      fileController.cancelSwitchToSelectText();
      let id = this.currentDoc.info.id;
      let aiFileId = this.docIdMap[id];
      // in addFn_openFile, will set value to currentDocAiFileId
      
      if(!this.openFileActionId && aiFileId === this.currentDocAiFileId){
        this.currentDocAiFileId = '';
      }
      delete this.docIdMap[id];
      delete this.docMap[id];
    }
    this.currentDoc = null;
    this.searchList = {}

    fileController.cleanAddedAnnotsList({type: 'all', uniqueIDNames: []})
  }

  addFn_getCurrentDoc(){
    this.fnMap['getCurrentDoc'] = async ({ /* method, data,  id,*/ resolve })=>{

      let doc = this.currentDoc || await window.pdfui.getCurrentPDFDoc();
      let files = [];
      if(doc){
        this.currentDoc = doc;
        let info = doc.info;
        let aiFileId = this.docIdMap[info.id];
        if(!aiFileId) aiFileId = this.currentDocAiFileId;
        let metaData = doc.metadata
        //{id, name, size, isCurrentDoc, account_id, filePath, drive}
        let file = {id: info.id, name: info.fileName , size: info.fileSize, isCurrentDoc: true, drive: 'local', metaData};
        aiFileId && (file['aiFileId'] = aiFileId)
        files = [file];
      }
      resolve({ret:0, data: files})
    }
  }
  /** 
   * begin label action:
   */
  addFn_labelToolStart(){
    this.fnMap['labelToolStart'] = async ({ /* method, data,  id,*/ resolve })=>{

      let doc = this.currentDoc || await window.pdfui.getCurrentPDFDoc();
      let result = {ret: 300001, data: null};
      if(doc){
        let isOk = await fileController.switchToSelectText({cancelSwitchToCallback:()=>{
          store.appStore.emitEvent(LABEL_TOOL_CANCELED, {});
        }});
        if(isOk){
          store.appStore.emitEvent(LABEL_TOOL_START, {});
          resolve({ret:0, data: null});
          return;
        }
      }
      resolve(result)
    }
  }
  addFn_labelToolEnd(){
    this.fnMap['labelToolEnd'] = async ({ /* method, data,  id,*/ resolve })=>{
      let doc = this.currentDoc || await window.pdfui.getCurrentPDFDoc();
      let result = {ret: 300001, data: null};
      if(doc){
        let dataItem = await fileController.getSelectedText();
        if(!dataItem) {
          result.ret = 400005;
        }else{
          result = {ret: 0, data: [dataItem]};
          fileController.cancelSwitchToSelectText();
          store.appStore.emitEvent(LABEL_TOOL_END, {});
        }
      }
      resolve(result)
    }
  }
  addFn_labelToolCancel(){
    this.fnMap['labelToolCancel'] = async ({ /* method, data,  id,*/ resolve })=>{
      let doc = this.currentDoc || await window.pdfui.getCurrentPDFDoc();
      if(doc){
        fileController.cancelSwitchToSelectText();
        store.appStore.emitEvent(LABEL_TOOL_CANCELED, {});
        resolve({ret:0, data: null})
        return;
      }
      resolve({ret:300001, data: null})
    }
  }

  addFn_isCurrentDocModified(){
    this.fnMap['isCurrentDocModified'] = async ({ /* method,  id, data,*/ resolve })=>{
      let doc = this.currentDoc || await window.pdfui.getCurrentPDFDoc();
      let isModified = doc? store.appStore.docModified: false;
      resolve({ret:0, data: isModified})
    }
  }

  addFn_getDocMetadata(){
    this.fnMap['getDocMetadata'] = async ({ /* method,  id, */data, resolve })=>{
      const {file} = data;
      if(!file||!file.isCurrentDoc){
        resolve({ret:100009})
        return;
      }
      let doc = this.currentDoc || await window.pdfui.getCurrentPDFDoc();
      if(!doc){
        resolve({ret:100009})
        return;
      }
      let metaData = doc.metadata
      resolve({ret:0, data: metaData})
    }
  }

  addFn_setIdToFile(){
    this.fnMap['setIdToFile'] = ({ /* method,  id, */data, resolve })=>{
      const {file, aiFileId} = data;
      if(this.currentDoc && this.currentDoc.info.id === file.id){
        this.currentDocAiFileId = aiFileId;
      }
      file.id && (this.docIdMap[file.id] = aiFileId);
      resolve({ret:0})
    }
  }
  // cancelGetStream
  addFn_cancelFileStream(){
    this.fnMap['cancelFileStream'] = ({ /* method,  id, */data, resolve })=>{
      const {files} = data;
      files.forEach((file)=>{
        delete this.docMap[file.id];
      })
      resolve({ret:0})
    }
  }

  downloadCloudFile(drive, file){
    return new Promise((resolve)=>{
      store.driveStore.doDownloadFile(this.drivesMap[drive], file, ({ blob }) => {
        resolve({ret:0, data: blob})
      }, (err)=>{
        console.error("downloadCloudFile -> err", err)
        resolve({ret:999})
      });
    })
  }
  /** @returns {Promise<Blob>} */
  async getFileBlob({file}){
    let fileBlob = null;
    if(this.docMap[file.id]){
      fileBlob = this.docMap[file.id];
      return fileBlob;
    }
    
    if(file.isCurrentDoc){
      let fileBuffer = (await fileController.getCurrentDocBuffer())[0];
      fileBlob = new Blob(fileBuffer, { type: 'application/pdf' });
      //window.__saveAs__(fileBlob, fileName)
      this.docMap[file.id] = fileBlob;
    }else{
      const {drive} = file;
      let oResult = await this.downloadCloudFile(drive, file);
      if(oResult.ret !== 0){
        return;
      }
      fileBlob = oResult.data;
      this.docMap[file.id] = fileBlob;
    }
    return fileBlob;
  }

  addFn_getFileStream(){
    this.fnMap['getFileStream'] = async ({ /* method,  id, */data, resolve })=>{
      /** @type {Blob} */
      let fileBlob = null;
      const {file, offset , blockSize} = data;

      store.appStore.openFileDlg.doChangeLoadingState(true)

      fileBlob = await this.getFileBlob({file});

      if(!fileBlob){
        resolve({ret:1})
        return;
      } 
      
      // slice buffer
      let fileSize = fileBlob.size;
      //let index = offset/blockSize>>>0;
      //let count = Math.ceil(fileSize / blockSize);
      // 0 + 1024, 0 + 1024 -1 => 1024 +1024, 1024 +1024 -1 => 
      let isEnd = (offset + blockSize) >= fileSize;
      let end = isEnd? fileSize: offset+blockSize;

      const bufferBlob = fileBlob.slice(offset, end, fileBlob.type);
      let dataSize = bufferBlob.size;
      // clean doc cache
      if(isEnd){
        delete this.docMap[file.id];
        store.appStore.doUpdateDocModified(false)
      }

      let result = await blobToBase64(bufferBlob);
      if(result.ret !== 0){
        resolve({ret:1})
        return;
      }
      let content = result.data.replace(/^data:[a-zA-Z\-\/]+;base64,/, "");
      
      resolve({ret:0, data:{content, isEnd, fileSize, dataSize }})
    }
  }

  addFn_releaseFileStream(){
    this.fnMap['releaseFileStream'] = async ({ /* method,  id, */data, resolve })=>{
      const {files} = data;

      files.forEach((file)=>{
        !!this.docMap[file.id] &&( delete this.docMap[file.id] );
      })

      resolve({ret:0, data:''})
      store.appStore.doUpdateDocModified(false)
    }
  }

  addFn_findTexts(){
    this.fnMap['findTexts'] = async ({ /* method,  id, */data, resolve })=>{
      //file, text, mode, startPage, endPage
      const {file, text, mode, startPage, endPage} = data;
      //
      let doc = this.currentDoc || await window.pdfui.getCurrentPDFDoc();
      if(!doc){
        resolve({ret:999});
        return;
      }

      if(file.id !== doc.info.id){
        resolve({ret:999});
        return;
      }
      let result;
      if(startPage === void 0 && endPage === void 0){
        result = await fileController.findTextInWholeDoc({doc, text, mode});
      }else{
        result = await fileController.findTextByPageRange({doc, text, mode, startPage, endPage});
      }
      if(result.length === 0){
        resolve({ret:0, data:{searchKey:'', count:0}})
        return;
      }
      let id = cuid();
      this.searchList[id] = {list: result, text};
      resolve({ret:0, data:{searchKey:id, count: result.length}})
    }
  }

  addFn_getFileTexts() {
    this.fnMap['getFileTexts'] = async({data, resolve}) =>{
      let doc = this.currentDoc || await window.pdfui.getCurrentDoc();

      const { pageIndex } = data;

      if (!doc) {
        resolve({ret: 999})
        return;
      }

      const result = await fileController.getFileTexts({doc, pageIndex});

      resolve({ret: 0, data: result})
    }
  }

  addFn_markTexts(){
    this.fnMap['markTexts'] = async ({ /* method,  id, */data, resolve })=>{
      const {searchKey, index} = data;
      if (!searchKey) {
        return resolve({ret:999});
      }
      let {list} = this.searchList[searchKey];
      if(!list){
        return resolve({ret:999});
      }

      let match = list[index];
      if(!match){
        return resolve({ret:999});
      }
      fileController.markTextSelection(match);
      resolve({ret:0});
    }
  }

  addFn_cleanLastMark(){
    this.fnMap['clearMarkTexts'] = async ({ /* method,  id, */data, resolve })=>{
      const {file} = data;
      
      //
      let doc = this.currentDoc || await window.pdfui.getCurrentPDFDoc();
      if(!doc){
        resolve({ret:999});
        return;
      }

      if(file.id !== doc.info.id){
        resolve({ret:999});
        return;
      }
      fileController.clearMarkTexts();
      resolve({ret:0});
    }
  }

  addFn_addAnnot(){
    this.fnMap['addAnnot'] = async ({ /* method,  id, */data, resolve })=>{
      let doc = this.currentDoc || await window.pdfui.getCurrentPDFDoc();
      if(!doc){
        resolve({ret:999});
        return;
      }
      const {searchKey, index, contents, type, uniqueIDName} = data;
      let {list} = this.searchList[searchKey];
      if(!list){
        return resolve({ret:999});
      }

      let match = list[index];
      if(!match){
        return resolve({ret:999});
      }

      let annots = await fileController.addAnnotBySearchMatch({doc, match, contents, type, uniqueIDName});

      match.uniqueIDName = uniqueIDName;

      await fileController.getRedactAnnots({match, type: 'redact', annots})

      resolve({ret:0});
    }
  }

  //addAnnotAtPoint
  addFn_addAnnotAtPoint(){
    this.fnMap['addAnnotAtPoint'] = async ({ /* method,  id, */data, resolve })=>{
      let doc = this.currentDoc || await window.pdfui.getCurrentPDFDoc();
      if(!doc){
        resolve({ret:999});
        return;  
      }
      
      const {pageIndex, point, contents, type, uniqueIDName} = data;

      fileController.addAnnotAtPoint({doc, pageIndex, point, contents, type, uniqueIDName})
      resolve({ret:0});
    }
  }
    //removeAnnotsAtPoint
  addFn_removeAnnotsAtPoint(){
    this.fnMap['removeAnnotsAtPoint'] = async ({ /* method,  id, */data, resolve })=>{
      let doc = this.currentDoc || await window.pdfui.getCurrentPDFDoc();
      if(!doc){
        resolve({ret:999});
        return;
      }

      const {pageIndex, point, type, uniqueIDPrefix} = data;

      fileController.removeAnnotsAtPoint({doc, pageIndex, point, type, uniqueIDPrefix})
      resolve({ret:0});
    }
  }
    //getAnnotsContentAtPoint
  addFn_getAnnotsContentAtPoint(){
    this.fnMap['getAnnotsContentAtPoint'] = async ({ /* method,  id, */data, resolve })=>{
      let doc = this.currentDoc || await window.pdfui.getCurrentPDFDoc();
      if(!doc){
        resolve({ret:999});
        return;
      }
      const {pageIndex, point, type, uniqueIDPrefix} = data;
      let list = await fileController.getAnnotsContentAtPoint({doc, pageIndex, point, type, uniqueIDPrefix})
      resolve({ret:0, data:list});
    }
    //const result = await  PluginJS.callFunction('base', "getAnnotsContentAtPoint", {pageIndex, point, type, uniqueIDPrefix})
    //return result;
  }

  addFn_getAnnots(){
    this.fnMap['getAnnots'] = async ({ /* method,  id, */data, resolve })=>{
      let doc = this.currentDoc || await window.pdfui.getCurrentPDFDoc();
      if(!doc){
        resolve({ret:999});
        return;
      }
      const {searchKey, index, type, uniqueIDPrefix} = data;
      let {list} = this.searchList[searchKey];
      if(!list){
        return resolve({ret:999});
      }

      let match = list[index];
      if(!match){
        return resolve({ret:999});
      }
      let ids = await fileController.getAnnotsBySearchMatch({doc, match, type, uniqueIDPrefix});
      resolve({ret:0, data:{ids}});
    }
  }

  addFn_removeAnnots(){
    this.fnMap['removeAnnots'] = async ({ /* method,  id, */data, resolve })=>{
      let doc = this.currentDoc || await window.pdfui.getCurrentPDFDoc();
      if(!doc){
        resolve({ret:999});
        return;
      }
      const {searchKey, index, type, uniqueIDPrefix/* , ids */} = data;
      let {list} = this.searchList[searchKey];
      if(!list){
        return resolve({ret:999});
      }

      let match = list[index];
      if(!match){
        return resolve({ret:999});
      }
      let ids = await fileController.getAnnotsBySearchMatch({doc, match, type, uniqueIDPrefix});
      if(!ids || ids.length === 0){
        return resolve({ret:0});
      }

      await fileController.cleanAddedAnnotsList({type: 'IDlist', uniqueIDNames: ids})

      await fileController.removeAnnotsBySearchMatch({doc, match, type, ids});
      
      resolve({ret:0, data:{ids}});
    }
  }

  addFn_redactApply() {
    this.fnMap['redactApply'] = async ({ /* method,  id, */data, resolve })=> {
      let doc = this.currentDoc || await window.pdfui.getCurrentPDFDoc();
      if(!doc){
        resolve({ret:999});
        return;
      }
      const {uniqueIDNames} = data;

      const matchList = [];

      for (let key in this.searchList) {
        await matchList.push.apply(matchList, this.searchList[key].list)
      }      

      store.appStore.onShowWarningMessage(async isOk => {
        if (isOk) {
          let uniqueIDNamesLength = uniqueIDNames.length;
          let matchListLength = matchList.length;
          let applyFailedList = []
  
          for (let i = 0; i < uniqueIDNamesLength; i++) {
            for (let j = 0; j < matchListLength; j++) {
              if (matchList[j].uniqueIDName === uniqueIDNames[i]) {
                const result = await fileController.redactApplyBySearchMatch({doc, type: 'redact', match: matchList[j], uniqueIDName: uniqueIDNames[i]})
  
                if (!result) {
                  applyFailedList.push(uniqueIDNames[i])
                }
              }
            }
          }
          resolve({ret:0, data: applyFailedList});
        } else {
          resolve({ret:999});
        }
      }, {
        message: 'autoRedaction.apply.msg',
        title: 'autoRedaction.apply.title',
        cancel: 'Cancel',
        ok: 'Ok'
      })
    }
  }

  addFn_saveDocument() {
    this.fnMap['saveDocument'] = async ({ /*data,*/ resolve }) => {
      //const { isSaveAs, suffix } = data

      fileController.saveToLocal(()=>{
        resolve({ret:0});
      }, null);
    }
  }

  addFn_setFormFieldValue(){
    this.fnMap['setFormFieldValue'] = async ({ /* method,  id, */data, resolve })=>{
      let doc = this.currentDoc || await window.pdfui.getCurrentPDFDoc();
      if(!doc){
        resolve({ret:999});
        return;
      }
      const {fieldName, value} = data;

      await fileController.setFormFieldValue({doc, fieldName, value});
      resolve({ret:0});
    }
    
  }
  addFn_replaceText(){
    this.fnMap['replaceText'] = async ({ /* method,  id, */data, resolve })=>{
      let doc = this.currentDoc || await window.pdfui.getCurrentPDFDoc();
      if(!doc){
        resolve({ret:999});
        return;
      }
      const {searchKey, index, text} = data;
      let {list} = this.searchList[searchKey];
      if(!list){
        return resolve({ret:999});
      }

      let match = list[index];
      if(!match){
        return resolve({ret:999});
      }

      await fileController.replaceText({doc, match, text});
      resolve({ret:0});
    }
    
  }
  addFn_showOpenFileDlg(){
    this.fnMap['showFileSelectDialog'] = ({ /* method, */data, /* id, */ resolve }) => {
      const {driveName} = data;
      const driveValue = this.drivesMap[driveName]

      store.driveStore.setDriveName(driveValue)
      store.appStore.showOpenFileDlg(true, driveValue, (/** @type {FileInfo[]} */files) => {
        files.forEach((file)=>{
          const {blob, drive, id} = file;

          file.app_name = 'PhantomOnline'
          
          if (drive && drive !== 'local') {
            file.drive = this.drivesMap[`${file.drive}`]
          }

          if(blob instanceof File){
            this.docMap[id] = blob;
            delete file[blob];
          }
        })
        
        store.appStore.openFileDlg.doChangeLoadingState(false);
        store.appStore.hideOpenFileDlg();

        resolve({ret:0, data: files})
      });
    };
  };
  addFn_openFile(){
    this.fnMap['openFile'] = ({ /* method,  */ data, id, resolve }) => {
      const {fileUrl, fileName, aiFileId, inNewTab} = data;
      if(inNewTab){
        let baseUrl = getBaseUrl();
        storageSetItem(localStorage, 'open_file_in_tab', JSON.stringify({
          fileUrl, fileName, aiFileId
        }))
        windowActionFn(window, 'open', [baseUrl + '?ai_file_id='+ aiFileId]);
        return;
      }

      const fn = (isOpen)=>{
        if(!isOpen){
          resolve({ret:999})
          return;
        }

        this.currentDocAiFileId = aiFileId;
        this.openFileActionId = id;
        fileController.doOpenFileByUrl(fileUrl, fileName, null, true).then((result)=>{
          let doc = result;
          let info = doc.info;
          this.docIdMap[info.id] = aiFileId;
          this.openFileActionId = '';
          
          resolve({ret:0})

        }).catch((err)=>{
        this.currentDocAiFileId = '';
        this.openFileActionId = '';
        console.error("addFn_openFile -> err", err)
        resolve({ret:999})
        })

      }
      const {docModified} = store.appStore;
      if(!docModified){
        fn(true);
        return;
      }
      store.appStore.isShowAi_openFile(true, fn)
    };
  };
  addFn_openUrlInBrowser(){
    this.fnMap['openUrlInBrowser'] = ({ /* method,  */ data, /* id, */ resolve }) => {
      const {url} = data;
      windowActionFn(window, 'open', [url]);
      resolve({ret:0})
    };
  }
  addFn_showMessage(){
    this.fnMap['showMessage'] = ({ /* method,  */ data, /* id, */ resolve }) => {
      const {type, title, content, duration} = data;
      //let hasButton = false;
      if(content.button){
        // hasButton = true;
        const cbValue = content.button.cb;
        const fn= ()=>{
          store.appStore.emitEvent(USER_MESSAGE_CALLBACK, cbValue);
        }
        content.button.cb = fn;
      }
      
      store.appStore.alertTips({type, title, content, duration})
      resolve({ret:0})
    };
  }
  addFn_createProgressBar() {
    this.fnMap['createProgressBar'] = ({ /* method,  */ /* data,*/ /* id, */ resolve}) => {

      store.appStore.showLoading(true)

      resolve({ret: 0})
    }
  }
  addFn_destroyProgressBar() {
    this.fnMap['destroyProgressBar'] = ({ /* method,  */ /* data,*/ /* id, */ resolve}) => {

      store.appStore.showLoading(false)
      
      resolve({ret: 0})
    }
  }
  addFn_checkFilePermission() {
    this.fnMap['checkFilePermission'] = async ({ /* method,  */ /* data,*/ /* id, */ resolve}) => {
      let doc = this.currentDoc || await window.pdfui.getCurrentPDFDoc();
      if(!doc){
        resolve({ret:999});
        return;
      }
      
      const result = await fileController.checkFilePermission({doc})

      resolve({ret: result})
    }
  }

}